<template>
  <div class="wrap">
    <h2>약국/약사 리스트</h2>
    <div class="hp_list">
      <div class="srch_area">
        <select v-model="order">
          <!-- <option value="0">관리자 지정순</option> -->
          <option value="join_date">최근가입순</option>
        </select>

        <select v-model="search_type">
          <option value="0">선택</option>
          <option value="pharmacist.pharm_id">회원번호</option>
          <option value="pharmacy.pharm_name">약국명</option>
          <option value="pharmacist.pharm_name">약사명</option>
          <option value="pharmacist.contact">휴대폰</option>
          <option value="pharmacist.email">이메일</option>
        </select>
        <a role="button" title="검색" class="btn_srch" @click="getPharmacistListData(page_no = 1)">검색</a>
        <div class="srch_box">
          <input type="text" v-model="search_name" v-on:keyup.enter="getPharmacistListData(page_no = 1)">
        </div>
      </div>
      <div class="tb_area">
        <table>
          <colgroup>
            <col width="5%">
            <!-- <col width="7%"> -->
            <col width="6%">
            <col width="10%">
            <col width="17%">
            <col width="8%">
            <col width="10%">
            <col width="13%">
            <col width="13%">
            <col width="11%">
          </colgroup>
          <tbody>
            <tr>
              <th scope="col">회원번호</th>
              <!-- <th scope="col">지역</th> -->
              <th scope="col">구분</th>
              <th scope="col">연계병원</th>
              <th scope="col">약국명</th>
              <th scope="col">약사명</th>
              <th scope="col">휴대폰</th>
              <th scope="col">이메일</th>
              <th scope="col">가입일시</th>
              <th scope="col">가입상태</th>
            </tr>
            
            <tr v-for="pharmacist in pharmacist_list" :class="{'on': (pharmacist.pharm_id == current_pharmacist_id)}" @click="chosen_row(pharmacist)" :key="pharmacist.pharm_id">
              <td>{{ pharmacist.pharm_id }}</td>
              <!-- <td>지역</td> -->
              <td>
                {{ 
                  pharmacist.is_appointed_pharmacy == 1 ? '지정' : 
                  pharmacist.is_door_pharmacy == 1 ? '문전' : 
                  '' 
                }}
              </td>
              <td>{{ pharmacist.door_pharmacy_dr_name }}</td>
              <td>{{ pharmacist.pharmacy_name }}</td>
              <td>{{ pharmacist.pharmacist_name }}</td>
              <td>{{ pharmacist.contact }}</td>
              <td>{{ pharmacist.email }}</td>
              <td>{{ pharmacist.join_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
              <td>
                {{ 
                  pharmacist.status == 0 ? '가입신청' : // 가입만 하고 관리자가 로그인 허용 하기 전 상태
                  pharmacist.status == 11 ? '가입완료' : // 관리자가 로그인 허용한 상태
                  pharmacist.status == 12 ? '검수요청' : // 사용자가 정보 입력완료후 승인요청한 상태
                  pharmacist.status == 1 ? '검수완료(승인완료)' : // 관리자가 검수승인완료한 상태
                  pharmacist.status == 13 ? '반려(검수보류)' : // 관리자가 승인 보류한 상태
                  pharmacist.status == 2 ? '일시정지' :
                  pharmacist.status == 14 ? '패널티' :
                  pharmacist.status == 15 ? '휴면' :
                  pharmacist.status == 9 ? '삭제' : ''
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <v-pagination v-model="page_no"
            :page-count="total_page"
            :classes="bootstrapPaginationClasses"
            @change="getPharmacistListData(page_no)">
        </v-pagination>
      </div>
    </div>

    <div class="mmbr_info" v-if="current_pharmacist_id">
      <ul class="tab">
        <li :class="{'on': (tab == 1)}" @click="changeTab(1)"><a role="button">계정 관리</a></li>
      </ul>
      <div id="tab1" class="tab_cont" style="display:block;" v-if="tab == 1">
        <div class="acunt">
          <div class="thmb_area">
            <div class="thmb">
              <div class="thmb_img">
                <img v-if="preview_pharm_img" :src="preview_pharm_img">
              </div>
              <div class="profile-img-change">
                <a @click.prevent="upload_button_click"><icon name="camera" class="camera-icon" title="프로필이미지"></icon></a>
                <input type="file" ref="pharmFileInput" style="display: none" @change="pharmacist_img_change" accept="image/*" capture="filesystem" />
              </div>
            </div>

            <p class="name">{{ pharmacy.pharm_name }}</p>
            <span class="stt">
              {{ 
                pharmacist.status == 0 ? '가입신청' : // 가입만 하고 관리자가 로그인 허용 하기 전 상태
                pharmacist.status == 11 ? '가입완료' : // 관리자가 로그인 허용한 상태
                pharmacist.status == 12 ? '검수요청' : // 사용자가 정보 입력완료후 승인요청한 상태
                pharmacist.status == 1 ? '검수완료(승인완료)' : // 관리자가 검수승인완료한 상태
                pharmacist.status == 13 ? '반려(검수보류)' : // 관리자가 승인 보류한 상태
                pharmacist.status == 2 ? '일시정지' :
                pharmacist.status == 14 ? '패널티' :
                pharmacist.status == 15 ? '휴면' :
                pharmacist.status == 9 ? '삭제' : ''
              }}
            </span>
          </div>
          <div class="info_area">
            <dl>
              <dt>계정정보</dt>
              <dd>
                <ul>
                  <li>
                    <p class="tt"><strong>*</strong>계정 UID</p>
                    <span class="input_box">{{ pharmacist.pharm_id }}</span>
                  </li>
                  <li>
                    <p class="tt"><strong>*</strong>가입 구분</p>
                    <span class="input_box">{{ pharmacist.is_pharmacy == '1' ? '약국' : '약사' }}</span>
                    <!-- <select name="is_hospital" v-model="dr.is_hospital" class="is_hospital_select">
                      <option v-for="(option, idx) in is_hospital_options" v-bind:value="option.value" :key="idx">
                        {{ option.text }}
                      </option>
                    </select> -->
                  </li>
                  <li>
                    <p class="tt"><strong>*</strong>약국명</p>
                    <span class="input_box"><input type="text" v-model="pharmacy.pharm_name"></span>
                  </li>
                  <li>
                    <p class="tt"><strong>*</strong>휴대폰</p>
                    <span class="input_box"><input type="text" v-model="pharmacist.contact"></span>
                  </li>
                  <li>
                    <p class="tt"><strong>*</strong>이메일</p>
                    <span class="input_box">{{ pharmacist.email }}</span>
                  </li>
                  <li>
                    <p class="tt"><strong>*</strong>약사명</p>
                    <span class="input_box"><input type="text" v-model="pharmacist.pharm_name"></span>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <dt>
                담당자 정보
                <span class="msg">* 약배송 접수등 알림톡을 받을 담당자 번호를 입력해 주세요. 미입력시 대표약사님에게만 알림톡이 갑니다.</span>
              </dt>
              <dd>
                <manager v-model="pharmacy.manager_arr" @set_new_manager_arr="set_new_manager_arr"></manager>
              </dd>
            </dl>
            <dl>
              <dt>
                담당 의사 정보
                <span class="msg">* 함께 이용하실 약사님이 있는 경우 추가해 주세요. 전체 약사님께 알림톡이 전송 되며 미입력 시 대표약사님에게만 알림톡이 갑니다.</span>
              </dt>
              <dd>
                <manager v-model="pharmacist.pharmacist_arr" @set_new_manager_arr="set_new_pharmacist_arr"></manager>
              </dd>
            </dl>
          </div>
        </div>
        <div class="tb_area">
          <table>
            <colgroup>
              <col width="25%">
              <col width="25%">
              <col width="25%">
              <col width="25%">
            </colgroup>
            <tbody>
              <tr>
                <th scope="col">가입일시</th>
                <th scope="col">승인(반려)자</th>
                <th scope="col">승인(반려)일시</th>
                <th scope="col">상태</th>
              </tr>
              <tr>
                <td>{{ pharmacist.join_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ pharmacist.approver_name ? pharmacist.approver_name : '(정보없음)' }}</td>
                <td>{{ pharmacist.approval_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>
                  {{
                    pharmacist.status_old == 0 ? '가입신청' : // 가입만 하고 관리자가 로그인 허용 하기 전 상태
                    pharmacist.status_old == 11 ? '가입완료' : // 관리자가 로그인 허용한 상태
                    pharmacist.status_old == 12 ? '검수요청' : // 사용자가 정보 입력완료후 승인요청한 상태
                    pharmacist.status_old == 1 ? '검수완료(승인완료)' : // 관리자가 검수승인완료한 상태
                    pharmacist.status_old == 13 ? '반려(검수보류)' : // 관리자가 승인 보류한 상태
                    pharmacist.status_old == 2 ? '일시정지' :
                    pharmacist.status_old == 14 ? '패널티' :
                    pharmacist.status_old == 15 ? '휴면' :
                    pharmacist.status_old == 9 ? '삭제' : ''
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tb_area">
          <table>
            <colgroup>
              <col width="13%" />
              <col width="37%" />
              <col width="25%" />
              <col width="25%" />
            </colgroup>
            <tbody>
              <tr>
                <th rowspan="4" scope="row">약국 구분</th>
                <td>지정 약국</td>
                <td colspan="2">
                  <input type="checkbox" id="is_appointed_pharmacy" name="is_appointed_pharmacy" v-model="pharmacy.is_appointed_pharmacy">
                </td>
              </tr>
              <tr>
                <td>문전 약국</td>
                <td>
                  <input type="checkbox" id="is_door_pharmacy" name="is_door_pharmacy" v-model="pharmacy.is_door_pharmacy">
                </td>
                <td>
                  <input type="text" v-model="pharmacy.door_pharmacy_dr_name" disabled>
                  <button type="button" class="btn_search" @click="searchDoorHospitalPopup">검색</button>
                </td>
              </tr>
            </tbody>
          </table>
          <table>
            <colgroup>
              <col width="13%">
              <col width="37%">
              <col width="">
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">사업자 등록번호</th>
                <td class="input_box"><input type="text" placeholder="사업자 등록번호를 입력해주세요." v-model="pharmacistSub.business_no"></td>
                <td class="tb_box">
                  <table>
                    <colgroup>
                      <col width="40%">
                      <col width="20%">
                      <col width="20%">
                      <col width="20%">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="col">*첨부파일</th>
                        <th scope="col">검수상태</th>
                        <th scope="col">검수(반려)자</th>
                        <th scope="col">검수(반려)일</th>
                      </tr>
                      <tr>
                        <td>
                          <div class="file_box">
                            <label class="btn_file" for="business_img_btn">파일등록</label>
                            <input type="file" id="business_img_btn" style="display: none" @change="business_img_change" accept="image/*" capture="filesystem" />
                          </div>
                          <div class="file_lnk">
                            <span v-if="pharmacistSub.business_img_uploading">{{ pharmacistSub.business_img_uploading }}</span>
                            <a v-else-if="pharmacistSub.business_img" @click="image_view_pop(pharmacistSub.business_img)">IMG 확인</a>
                          </div>
                        </td>
                        <td>
                          <select name="business_status" v-model="pharmacistSub.business_status">
                            <option :value="0">선택</option>
                            <option :value="1">검수대기</option>
                            <option :value="2">승인</option>
                            <option :value="3">반려</option>
                          </select>
                        </td>
                        <td>{{ pharmacistSub.business_examiner_name ? pharmacistSub.business_examiner_name : '(정보없음)' }}</td>
                        <td>{{ pharmacistSub.business_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <!-- 병원 일때만 노출 -->
              <tr>
                <th scope="row">은행계좌번호</th>
                <td>
                  <dl>
                    <dt>은행명</dt>
                    <dd>
                      <select name="bank_code" id="bank_code" v-model="pharmacistSub.bank_code">
                        <option :value="0">선택</option>
                        <option v-for="row in bankList" :value="row.idx" :key="row.idx">{{ row.subject }}</option>
                      </select>
                    </dd>
                    <dt>계좌번호</dt>
                    <dd>
                      <input type="text" v-model="pharmacistSub.bank_account_no">
                    </dd>
                  </dl>
                </td>
                <td class="tb_box">
                  <table>
                    <colgroup>
                      <col width="40%">
                      <col width="20%">
                      <col width="20%">
                      <col width="20%">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="col">*첨부파일</th>
                        <th scope="col">검수상태</th>
                        <th scope="col">검수(반려)자</th>
                        <th scope="col">검수(반려)일</th>
                      </tr>
                      <tr>
                        <td>
                          <div class="file_box">
                            <label class="btn_file" for="bank_account_img_btn">파일등록</label>
                            <input type="file" id="bank_account_img_btn" style="display: none" @change="bank_account_img_change" accept="image/*" capture="filesystem" />
                          </div>
                          <div class="file_lnk">
                            <span v-if="pharmacistSub.bank_account_img_uploading">{{ pharmacistSub.bank_account_img_uploading }}</span>
                            <a v-else-if="pharmacistSub.bank_account_img" @click="image_view_pop(pharmacistSub.bank_account_img)">IMG 확인</a>
                          </div>
                        </td>
                        <td>
                          <select name="bank_account_status" v-model="pharmacistSub.bank_account_status">
                            <option :value="0">선택</option>
                            <option :value="1">검수대기</option>
                            <option :value="2">승인</option>
                            <option :value="3">반려</option>
                          </select>
                        </td>
                        <td>{{ pharmacistSub.bank_account_examiner_name ? pharmacistSub.bank_account_examiner_name : '(정보없음)' }}</td>
                        <td>{{ pharmacistSub.bank_account_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <!-- <tr>
                <th scope="row">면허증 번호</th>
                <td class="input_box"><input type="text" placeholder="면허증 번호를 입력해주세요." v-model="pharmacist.license_no"></td>
                <td class="tb_box">
                  <table>
                    <colgroup>
                      <col width="40%">
                      <col width="20%">
                      <col width="20%">
                      <col width="20%">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="col">*첨부파일</th>
                        <th scope="col">검수상태</th>
                        <th scope="col">검수(반려)자</th>
                        <th scope="col">검수(반려)일</th>
                      </tr>
                      <tr>
                        <td>
                          <div class="file_box">
                            <label class="btn_file" for="license_img_btn">파일등록</label>
                            <input type="file" id="license_img_btn" style="display: none" @change="license_img_change" accept="image/*" capture="filesystem" />
                          </div>
                          <div class="file_lnk">
                            <span v-if="pharmacist.license_img_uploading">{{ pharmacist.license_img_uploading }}</span>
                            <a v-else-if="pharmacist.license_img" @click="image_view_pop(pharmacist.license_img)">IMG 확인</a>
                          </div>
                        </td>
                        <td>
                          <select name="license_status" v-model="pharmacistSub.license_status">
                            <option :value="0">선택</option>
                            <option :value="1">검수대기</option>
                            <option :value="2">승인</option>
                            <option :value="3">반려</option>
                          </select>
                        </td>
                        <td>{{ pharmacistSub.license_examiner_name ? pharmacistSub.license_examiner_name : '(정보없음)' }}</td>
                        <td>{{ pharmacistSub.license_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr> -->
            </tbody>
          </table>
        </div>

        <div class="hp_info">
          <h3>약국 정보</h3>
          <table>
            <tbody>
              <tr>
                <th scope="col">약국 주소</th>
                <td colspan="3">
                    <div class="addr_srch">
                        <select id="addr_short" name="addr_short" v-model="pharmacy.addr_short">
                          <option v-for="row in locationCodes" :value="row" :key="row.idx">{{ row }}</option>
                        </select>
                        <a role="button" class="btn bt_addr" @click.prevent="locationPopup()">주소검색</a>
                    </div>
                    <div class="addr_box">
                        <input type="text" class="addr" v-model="pharmacy.location" readonly />
                        <input type="text" class="addr" v-model="pharmacy.addr_detail"/>
                    </div>
                </td>
              </tr>
              <tr>
                <th scope="col">약국 전화번호</th>
                <td colspan="3">
                  <ContactInput v-model="pharmacy.pharm_tel" class="contact-test"></ContactInput>
                </td>
              </tr>
              <tr>
                <th scope="col">약국 팩스번호</th>
                <td colspan="3">
                  <ContactInput v-model="pharmacist.pharmacy_fax" class="contact-test"></ContactInput>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="tb_area">
          <table class="agree">
            <colgroup>
              <col width="25%" />
              <col width="25%" />
              <col width="25%" />
              <col width="25%" />
            </colgroup>
            <tbody>
              <tr>
                <th socpe="col" colspan="2">일반 약관 동의 여부(전화처방/해외처방)</th>
                <th scope="col" colspan="2">병원/약국 약관 동의 여부</th>
              </tr>
              <tr class="sub_th">
                <th scope="col">동의여부</th>
                <th scope="col">동의일시</th>
                <th scope="col">동의여부</th>
                <th scope="col">동의일시</th>
              </tr>
              <tr>
                <td>{{ pharmacist.is_general_terms == 1 ? 'O' : 'X' }}</td>
                <td>{{ pharmacist.general_terms_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
                <td>{{ pharmacist.is_special_terms == 1 ? 'O' : 'X' }}</td>
                <td>{{ pharmacist.special_terms_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
                
              </tr>
            </tbody>
          </table>
          <table>
            <colgroup>
              <col width="25%" />
              <col width="25%" />
              <col width="25%" />
              <col width="25%" />
            </colgroup>
            <tbody>
              <tr>
                <th rowspan="5" scope="row">마케팅 정보제공동의</th>
                <th scope="col">동의 항목</th>
                <th scope="col">동의 여부</th>
                <th scope="col">동의 일시</th>
              </tr>
              <tr>
                <td>SMS</td>
                <td>{{ pharmacist.is_marketing_sms == 1 ? 'O' : 'X' }}</td>
                <td>{{ pharmacist.marketing_sms_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
              </tr>
              <tr>
                <td>이메일</td>
                <td>{{ pharmacist.is_marketing_email == 1 ? 'O' : 'X' }}</td>
                <td>{{ pharmacist.marketing_email_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
              </tr>
              <tr>
                <td>알림톡</td>
                <td>{{ pharmacist.is_marketing_talk == 1 ? 'O' : 'X' }}</td>
                <td>{{ pharmacist.marketing_talk_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
              </tr>
              <tr>
                <td>기타</td>
                <td>{{ pharmacist.is_marketing_etc == 1 ? 'O' : 'X' }}</td>
                <td>{{ pharmacist.marketing_etc_date | date_format('YYYY-MM-DD HH:mm:ss') }}</td>
              </tr>
              <tr>
                <th>상태</th>
              <!--               
              - 가입신청 : 로그인 불가
              - 가입완료 : 로그인 가능
              - 검수요청 : 정보 입력완료후 신청
              - 검수완료(승인완료) : 관리자가 검수승인완료한 경우
              - 반려(검수보류) : 관리자가 승인 보류한 경우
              -->
                <td colspan="3" class="dvic">
                    <input id="dv_ck1" type="radio" name="status" :value="0" v-model="pharmacist.status">
                    <label for="dv_ck1">가입신청</label>

                    <input id="dv_ck2" type="radio" name="status" :value="11" v-model="pharmacist.status">
                    <label for="dv_ck2">가입완료</label>

                    <input id="dv_ck3" type="radio" name="status" :value="12" v-model="pharmacist.status">
                    <label for="dv_ck3">검수요청</label>

                    <input id="dv_ck4" type="radio" name="status" :value="1" v-model="pharmacist.status">
                    <label for="dv_ck4">검수완료(승인완료)</label>

                    <input id="dv_ck5" type="radio" name="status" :value="13" v-model="pharmacist.status">
                    <label for="dv_ck5">반려(검수보류)</label>

                    <input id="dv_ck6" type="radio" name="status" :value="2" v-model="pharmacist.status">
                    <label for="dv_ck6">일시정지</label>

                    <input id="dv_ck7" type="radio" name="status" :value="14" v-model="pharmacist.status">
                    <label for="dv_ck7">패널티</label>

                    <input id="dv_ck8" type="radio" name="status" :value="15" v-model="pharmacist.status">
                    <label for="dv_ck8">휴면</label>

                    <input id="dv_ck9" type="radio" name="status" :value="9" v-model="pharmacist.status">
                    <label for="dv_ck9">삭제</label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="profile-btn">
          <button type="button" class="btn_sv" @click="save('account')">저장</button>
        </div>
      </div>

    </div>
    
    <div id="myModal" class="modal" v-if="is_modal">
      <div class="modal-content">
        <div class="modal-header">
          <span class="close" @click="justClosePopup()">&times;</span>
          <h1>주소 검색</h1>
        </div>
        <div class="modal-body">
          <DoorHospital @closeEvent="selectDoorHospital"></DoorHospital>
        </div>
      </div>
    </div>

    <div id="myModal2" class="modal" v-if="is_modal2">
      <div class="modal-content">
        <div class="modal-header">
          <span class="close" @click="justClosePopup2()">&times;</span>
          <h1>주소 검색</h1>
        </div>
        <div class="modal-body">
          <Location @closeEvent="closeLocationPopup"></Location>
        </div>
      </div>
    </div>
  </div>

  
</template>

<script>
import { mapState } from 'vuex'
import Manager from '@/components/ProfileEdit/Manager.vue'
import Upload from '@/lib/upload'
import { UPLOAD_TYPE } from '@/lib/constants'
import { nameByConstMixin } from '@/lib/mixins'
import DoorHospital from '@/components/Common/doorHospital.vue'
import vPagination from '@/components/Common/Paging.vue'
import ContactInput from '@/components/Common/ContactInput.vue'
import Location from '@/components/Common/Location.vue'
import py_api from '../lib/python'

export default {
  mixins: [nameByConstMixin],
  name: 'dr-list-admin',
  data () {
    return {
      //페이징 관련
      total_count: 0, //총 건수
      total_page: 1, //총 페이지 번호
      page_no : 1, //현재 페이지 번호
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      // order: 0, // 정렬순서
      order: 'join_date', // 정렬순서
      // search_type: 0,
      search_type: 'pharmacy.pharm_name',
      search_name: null,
      pharmacist_list: [],
      current_pharmacist_id: null, //선택한 row의 dr_id
      current_pharmacist: {}, //선택한 row의 memo_id, list에서 받아옴?

      // is_hospital_options: [
      //   { text: '병원', value: 'Y' },
      //   { text: '의사', value: 'N' },
      //   // { text: '간호사', value: 'C' },
      // ],
      pharmacist: {
        pharm_id: null,
        pharm_name: null,
        pharm_img: null,
        pharm_img_sm: null,
        pharmacy_id: null,
        pharmacist_imgs: [], // 서버에서 내려주는 가공된 이미지 데이터(W/ URL)
        del_imgs: [], // 삭제할때는 이 image hash_id
        uploaded_files: [], // 업로드가 있을때만 보낸다.
        pharmacist: [], // 담당의사 
        pharmacist_tel: [], // 담당전화번호 
        pharmacist_arr: [],
        email: null,
        contact: null,
        join_date: null,
        approval_date: null,
        approver: null,
        approver_name: null,
        status: null,
        // license_no: null, //기존에 있던 컬럼이므로 dr에 있음(다른 자료는 sub 테이블에 있음)
        // license_img: null, ////기존에 있던 컬럼이므로 dr에 있음(다른 자료는 sub 테이블에 있음)
        // license_img_uploading: null, // 파일 첨부 했을 시 파일명 보여주기 위해
        is_general_terms: null, //일반 약관 동의 여부(0: 비동의, 1: 동의)
        is_special_terms: null, //병원/약국 약관 동의 여부(0: 비동의, 1: 동의)
        is_marketing_sms: null, //마케팅 정보 제공 동의(SMS)(0: 비동의, 1: 동의)
        is_marketing_email: null, //마케팅 정보 제공 동의(이메일)(0: 비동의, 1: 동의)
        is_marketing_talk: null, //마케팅 정보 제공 동의(알림톡)(0: 비동의, 1: 동의)
        is_marketing_etc: null, //마케팅 정보 제공 동의(기타)(0: 비동의, 1: 동의)
        general_terms_date: null, // 일반 약관 동의일
        special_terms_date: null, // 병원/약국 약관 동의일
        marketing_sms_date: null, // 마케팅 정보 제공 동의일(SMS)
        marketing_email_date: null, // 마케팅 정보 제공 동의일(이메일)
        marketing_talk_date: null, // 마케팅 정보 제공 동의일(알림톡)
        marketing_etc_date: null, // 마케팅 정보 제공 동의일(기타)
        status_old: 0, // 선택한 상태와 기존의 상태(old)를 비교하여 검수자, 검수일 등을 Update할지 판단하기 위해 기존 상태 저장
        is_pharmacy: null, // 1: 약국, 0: 약사

        pharmacy_fax: null,
        latitude: '',
        longitude: '',
      },
      pharmacy: {
        pharm_id: '',
        pharm_name: '',
        manager: [],
        manager_tel: [],
        pharmacy_imgs: [], // 서버에서 내려주는 가공된 이미지 데이터(W/ URL)
        del_imgs: [], // 삭제할때는 이 image hash_id
        uploaded_files: [], // 업로드가 있을때만 보낸다.
        manager_arr: [], //manager배열과 manager_tel 배열을 한 배열로 합친다.
        is_appointed_pharmacy: 0, // 지정 약국 여부
        is_door_pharmacy: 0, // 문전 약국 여부
        door_pharmacy_dr_id: null, // 문전 약국 연계병원 id(doctor.dr_id)
        door_pharmacy_dr_name: null, // 문전 약국 연계병원 id(doctor.dr_name)

        addr_short: null,
        location: null,
        addr_detail: null,
        pharm_tel: null,
      },
      pharmacistSub: {
        sub_id: null, //의사 sub_id
        pharm_id: null, //의사id
        // license_status: 0, //의사 면허증 검수상태(1: 검수대기, 2: 승인, 3: 반려)
        // license_examiner: null, //의사 면허증 검수자
        // license_examiner_name: null, //의사 면허증 검수자
        // license_date: null, //의사 면허증 검수일
        business_no: null, //사업자 등록 번호
        business_img: null, //사업자 등록 이미지
        business_status: 0, //사업자 검수상태(1: 검수대기, 2: 승인, 3: 반려)
        business_examiner: null, //사업자 검수자
        business_examiner_name: null, //사업자 검수자
        business_date: null, //사업자 검수일
        bank_code: 0,
        bank_account_no: null, //은행 계좌 번호
        bank_account_img: null, //은행 계좌 이미지
        bank_account_status: 0, //은행 계좌 검수상태(1: 검수대기, 2: 승인, 3: 반려)
        bank_account_examiner: null, //은행 계좌 검수자
        bank_account_examiner_name: null, //은행 계좌 검수자
        bank_account_date: null, //은행 계좌 검수일
        business_img_uploading: null, // 파일 첨부 했을 시 파일명 보여주기 위해
        bank_account_img_uploading: null, // 파일 첨부 했을 시 파일명 보여주기 위해
        // license_status_old: 0, // 선택한 상태와 기존의 상태(old)를 비교하여 검수자, 검수일 등을 Update할지 판단하기 위해 기존 상태 저장
        business_status_old: 0, // 선택한 상태와 기존의 상태(old)를 비교하여 검수자, 검수일 등을 Update할지 판단하기 위해 기존 상태 저장
        bank_account_status_old: 0, // 선택한 상태와 기존의 상태(old)를 비교하여 검수자, 검수일 등을 Update할지 판단하기 위해 기존 상태 저장
      },
      upload_obj: null, // 프로파일 이미지
      preview_pharm_img: '',
      is_click: true,
      bankList: [], // 은행 Select
      tab: 1, //계정 관리, 프로필 관리 탭
      // license_img_upload_obj: '', // 미리보기용 이미지 ?
      business_img_upload_obj: '', // 미리보기용 이미지 ?
      bank_account_upload_obj: '', // 미리보기용 이미지 ?
      is_modal: false, //문전 약국 검색 modal popup
      locationCodes: [], //지역 필터 검색시 필요함, 지역 필터 검색 코드를 불러옴
      is_modal2: false, //주소검색 modal popup
    }
  },
  computed: {
    ...mapState(['account']),
  },
  methods: {
    chosen_row (pharmacist) {
      this.current_pharmacist_id = pharmacist.pharm_id;
      this.onSelectRow(pharmacist);
    },
    async onSelectRow (pharmacist){
      this.current_pharmacist = pharmacist;
    },
    changeTab(tab) {
      this.tab = tab;
    },
    image_view_pop(img) { //첨부파일 이미지 보기
      let img_detail = '';
      if(img){
        img_detail = window.open(img, "img_detail", "width=800, height=800");
      }
    },
    upload_button_click () {
      this.$refs.pharmFileInput.click()
    },
    searchDoorHospital(){
      alert('준비중 입니다.');
    },
    async getPharmacistData (pharm_id) {
      Object.assign(this.$data.pharmacist, this.$options.data().pharmacist);
      let chosen_fields = Object.keys(this.pharmacist)
      let {data: {resp}} = await this.axios.get(`pharmacist/${pharm_id}`)

      for (let key of chosen_fields) {
        if (key in resp) {
          this.pharmacist[key] = resp[key]
        }
      }

      this.preview_pharm_img = resp.pharm_img_sm;
      this.pharmacist.status_old = resp.status;
    },
    async getPharmacistSubData(pharm_id) {
      Object.assign(this.$data.pharmacistSub, this.$options.data().pharmacistSub);
      let chosen_fields = Object.keys(this.pharmacistSub)
      let {data: {resp}} = await this.axios.get(`pharmacist/sub/${pharm_id}`)

      for (let key of chosen_fields) {
        if (key in resp) {
          this.pharmacistSub[key] = resp[key]
        }
      }

      // this.pharmacistSub.license_status_old = resp.license_status;
      this.pharmacistSub.business_status_old = resp.business_status;
      this.pharmacistSub.bank_account_status_old = resp.bank_account_status;
    },
    async getPharmacyData (pharm_id) {
      Object.assign(this.$data.pharmacy, this.$options.data().pharmacy);

      if(pharm_id){
        let chosen_fields = Object.keys(this.pharmacy)
        let {data: {resp}} = await this.axios.get(`pharmacy/${pharm_id}`)

        for (let key of chosen_fields) {
          if (key in resp) {
            this.pharmacy[key] = resp[key];
          }
        }
      }else{
      }
    },
    async getBank () {
      await this.axios({
        method: 'get',
        url: '/appdata/code/25', // 노출 타입 구분
      }).then((response) => {
        if(response.data.status == '200'){
          if(response.data.resp){
            this.bankList = response.data.resp;
          }
        }else{
          //alert('오류가 발생 했습니다.');
          console.log('error!');
        }
      }).catch((error) => {
          console.log('error!: ', error);
      });
    },
    async getPharmacistListData (page_no = 1, refresh) {
      if(refresh == 'N'){

      }else{
        this.current_pharmacist_id = null;
      }      
      
      let params = {
        page: page_no,
      }

      if(this.search_type && this.search_name){
        params.search_type = this.search_type;
        params.search_name = this.search_name;
      }

      if(this.order){
        params.order = this.order;
      }

      await this.axios({
        method: 'get',
        url: '/pharmacist/admin',
        params: params,
      }).then((response) => {
        // console.log(response);
        if(!response.data.has_error){ //성공  
          if(response.data.resp.list){
            this.pharmacist_list = response.data.resp.list;
          }
          this.total_count = response.data.resp.total_count
          this.total_page = Math.ceil(this.total_count / 10);
        }else{ //실패

        }
      }).catch((error) => {
          console.log('error!: ', error);
      }).finally(() => {
          
      });
    },
    
    // license_img_change (event) { // 면허증 이미지 변경
    //   let file_kind = event.target.name;
    //   let upload_files = event.target.files;
    //   const reader = new FileReader();
    //   reader.onload = (e) => {
    //     this.license_img_preview = e.target.result;
    //   }
    //   reader.readAsDataURL(upload_files[0])
    //   this.license_img_upload_obj = new Upload(UPLOAD_TYPE.PHARM_LIC_IMG, {key_id: this.pharmacist.pharm_id})
    //   for (let file of upload_files) {
    //     this.license_img_upload_obj.append(file)
    //   }
    //   this.pharmacist.license_img_uploading = upload_files[0].name;
    // },
    business_img_change (event) { // 사업자 등록번호 이미지 변경
      let file_kind = event.target.name;
      let upload_files = event.target.files;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.business_img_preview = e.target.result;
      }
      reader.readAsDataURL(upload_files[0])
      this.business_img_upload_obj = new Upload(UPLOAD_TYPE.PHARM_BUS_IMG, {key_id: this.pharmacist.pharm_id})
      for (let file of upload_files) {
        this.business_img_upload_obj.append(file)
      }
      this.pharmacistSub.business_img_uploading = upload_files[0].name;
    },
    bank_account_img_change (event) { // 은행계좌번호 이미지 변경
      let file_kind = event.target.name;
      let upload_files = event.target.files;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.bank_account_img_preview = e.target.result;
      }
      reader.readAsDataURL(upload_files[0])
      this.bank_account_upload_obj = new Upload(UPLOAD_TYPE.PHARM_ACC_IMG, {key_id: this.pharmacist.pharm_id})
      for (let file of upload_files) {
        this.bank_account_upload_obj.append(file)
      }
      this.pharmacistSub.bank_account_img_uploading = upload_files[0].name;
    },
    pharmacist_img_change (event) {
      let file_kind = event.target.name;
      let upload_files = event.target.files;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.preview_pharm_img = e.target.result;
      }
      reader.readAsDataURL(upload_files[0])
      this.upload_obj = new Upload(UPLOAD_TYPE.PHARM_IMG, {key_id: this.pharmacist.pharm_id, resize_width: 400})
      for (let file of upload_files) {
        this.upload_obj.append(file)
      }
    },
    async img_upload_pharmacist (key_id, resize_width) {
      let upload = new Upload(UPLOAD_TYPE.PHARM_IMG, {key_id, resize_width})

      for (let [idx, [img_seq, img_url, file_obj]] of this.pharmacist.pharmacist_imgs.entries()) {
        if (img_seq === 'new') {
          upload.append(file_obj)
          this.pharmacist.pharmacist_imgs[idx] = 'uploaded' // 중복저장을 막기 위해서 처리.
        }
      }

      let resp = await upload.done()
      return resp.uploaded_sm_files
    },
    async createPharmacy (pharmacy_data) {
      let new_data = Object.assign({}, this.pharmacy, pharmacy_data) // 꼭 state는 Object.assign 으로 데이터를 빼줘야 한다.
      delete new_data.pharmacy_imgs // 보기 전용 데이터 임으로 삭제한다. (payload 크기 413 문제로 꼭 지워줘야 한다)
      let {data: {resp}} = await this.axios.post('pharmacy', new_data)
      return resp.pharm_id
    },
    async location_list () {  //전문 진료 분야 가져오기 20190411 kjw        
        await this.axios({
          method: 'get',
          url: '/appdata/code/21', //앱에서 필터검색에 사용하는 코드
          params: {code: 12},
        }).then((response) => {
          //console.log(response);
          if(response.data.status == '200'){
            let locationStr = response.data.resp[0].subject;
            
            if(locationStr){
              this.locationCodes = locationStr.split(',');
            }
          }else{
            //alert('오류가 발생 했습니다.');
          }
        }).catch((error) => {
            console.log('error!: ', error);
        });
    },
    async locationPopup(){
      this.is_modal2 = true;
    },
    async closeLocationPopup(event) {
      // console.log(event);

      if(event.address){
        this.pharmacy.location = event.address;
        let locationResult = await py_api.location(this.pharmacy.location);

        // 호출 결과가 null이 아니고 에러가 아닐경우 -> 성공
        if(locationResult && !locationResult.has_error){
          // console.log('성공');
          this.pharmacist.latitude = locationResult.resp.lat;
          this.pharmacist.longitude = locationResult.resp.lng;
        }else{
          // console.log('실패');
          alert('주소가 정확하지 않습니다. 확인해 주세요');
          return false;
        }
      }
      this.is_modal2 = false;
    },
    async justClosePopup2(){
      this.is_modal2 = false;
    },
    async save (type) {
      if(this.pharmacy.is_appointed_pharmacy && this.pharmacy.is_door_pharmacy){
        alert('지정약국과 문전약국을 동시에 설정 하실 수 없습니다.');
        return false;
      }
      if(!this.pharmacist.pharmacy_id){ // 저장된 HOSPITAL 테이블 데이터가 없으면 먼저 저장 한다.
        let pharmacy_id = await this.createPharmacy(this.pharmacy);
        this.pharmacist.pharmacy_id = pharmacy_id;
        this.pharmacy.pharm_id = pharmacy_id;
      }      
      let data = {
        pharmacist: {
        },
        pharmacistSub: {
        },
        pharmacy: {
        },
      }

      if(type == 'account'){ // 계정 관리 저장
        // 제일 상단 의사 사진
        if (this.upload_obj) {
          let resp1 = await this.upload_obj.done()

          let [hash_key, filename] = resp1.uploaded_files[0]
          this.pharmacist.pharm_img = filename

          let [hash_key2, filename2] = resp1.uploaded_sm_files[0]
          this.pharmacist.pharm_img_sm = filename2
        } else {
          delete this.pharmacist.pharm_img // 원본 필드명과 같이 사용하다 보니 서버에서 내려온 http:// 시작하는 주소가 덮어써지는걸 방지하기 위해서
          delete this.pharmacist.pharm_img_sm
        }
        
        //의사 소개 이미지 추가 20191029 kjw
        let uploaded_sm_files_pharmacist = await this.img_upload_pharmacist(this.pharmacist.pharm_id, 800)
        this.pharmacist.uploaded_files = uploaded_sm_files_pharmacist
        data.pharmacist.pharm_img = this.pharmacist.pharm_img
        data.pharmacist.pharm_img_sm = this.pharmacist.pharm_img_sm
        data.pharmacist.uploaded_files= this.pharmacist.uploaded_files
        
        // 면허증 첨부파일
        // if (this.license_img_upload_obj) {
        //   let resp = await this.license_img_upload_obj.done();
        //   let [hash_key, filename] = resp.uploaded_files[0]
        //   this.pharmacist.license_img = filename
        // } else {
        //   delete this.pharmacist.license_img // 원본 필드명과 같이 사용하다 보니 서버에서 내려온 http:// 시작하는 주소가 덮어써지는걸 방지하기 위해서
        // }
        //console.log(this.dr.license_img);

        // 사업자 등록번호 첨부파일
        if (this.business_img_upload_obj) {
          let resp = await this.business_img_upload_obj.done();
          let [hash_key, filename] = resp.uploaded_files[0]
          this.pharmacistSub.business_img = filename
        } else {
          delete this.pharmacistSub.business_img // 원본 필드명과 같이 사용하다 보니 서버에서 내려온 http:// 시작하는 주소가 덮어써지는걸 방지하기 위해서
        }
        //console.log(this.drSub.business_img);

        // 은행계좌번호 첨부파일
        if (this.bank_account_upload_obj) {
          let resp = await this.bank_account_upload_obj.done();
          let [hash_key, filename] = resp.uploaded_files[0]
          this.pharmacistSub.bank_account_img = filename
        } else {
          delete this.pharmacistSub.bank_account_img // 원본 필드명과 같이 사용하다 보니 서버에서 내려온 http:// 시작하는 주소가 덮어써지는걸 방지하기 위해서
        }
        //console.log(this.drSub.bank_account_img);

        data.pharmacist.pharm_id = this.pharmacist.pharm_id; //KEY
        data.pharmacist.pharmacy_id = this.pharmacist.pharmacy_id; //KEY
        data.pharmacy.pharm_name = this.pharmacy.pharm_name; // 병원 이름
        data.pharmacist.pharm_name = this.pharmacist.pharm_name; // 병원 이름
        data.pharmacist.contact = this.pharmacist.contact;
        data.pharmacy.manager = this.pharmacy.manager;
        data.pharmacy.manager_tel = this.pharmacy.manager_tel;
        data.pharmacist.pharmacist = this.pharmacist.pharmacist;
        data.pharmacist.pharmacist_tel = this.pharmacist.pharmacist_tel;
        // data.pharmacist.license_no = this.pharmacist.license_no; // 면허증 등록번호
        // data.pharmacist.license_img = this.pharmacist.license_img; // 면허증 첨부파일
        data.pharmacistSub.business_no = this.pharmacistSub.business_no; // 사업자 등록번호
        data.pharmacistSub.business_img = this.pharmacistSub.business_img; // 사업자 첨부파일
        data.pharmacistSub.bank_code = this.pharmacistSub.bank_code;
        data.pharmacistSub.bank_account_no = this.pharmacistSub.bank_account_no; // 은행계좌 번호
        data.pharmacistSub.bank_account_img = this.pharmacistSub.bank_account_img; // 은행계좌 첨부파일
        data.pharmacy.is_appointed_pharmacy = this.pharmacy.is_appointed_pharmacy; // 지정약국 여부
        data.pharmacy.is_door_pharmacy = this.pharmacy.is_door_pharmacy; // 문전약국 여부
        if(this.pharmacy.door_pharmacy_dr_id == ''){
          data.pharmacy.door_pharmacy_id = null; // 문전약국 연계 병원 dr_id
        }else{
          data.pharmacy.door_pharmacy_id = this.pharmacy.door_pharmacy_dr_id; // 문전약국 연계 병원 dr_id
        }

        // if(this.pharmacistSub.license_status_old != this.pharmacistSub.license_status){ // 기존과 검수상태 변경 됐으면
        //   // console.log(this.pharmacistSub.license_status);
        //   data.pharmacistSub.license_status = this.pharmacistSub.license_status; // 검수상태
        //   if(this.pharmacistSub.license_status == '2' || this.pharmacistSub.license_status == '3'){ // 승인 or 반려일시
        //     data.pharmacistSub.license_examiner = this.account.pharm_id; // 검수자
        //   }
        // }
        if(this.pharmacistSub.business_status_old != this.pharmacistSub.business_status){ // 기존과 검수상태 변경 됐으면
          data.pharmacistSub.business_status = this.pharmacistSub.business_status; // 검수상태
          if(this.pharmacistSub.business_status == '2' || this.pharmacistSub.business_status == '3'){
            data.pharmacistSub.business_examiner = this.account.pharm_id; // 검수자
          }
        }
        if(this.pharmacistSub.bank_account_status_old != this.pharmacistSub.bank_account_status){ // 기존과 검수상태 변경 됐으면
          data.pharmacistSub.bank_account_status = this.pharmacistSub.bank_account_status; // 검수상태
          if(this.pharmacistSub.bank_account_status == '2' || this.pharmacistSub.bank_account_status == '3'){
            data.pharmacistSub.bank_account_examiner = this.account.pharm_id; // 검수자
          }
        }

        if(this.pharmacist.status_old != this.pharmacist.status){ // 기존과 검수상태 변경 됐으면
          data.pharmacist.status = this.pharmacist.status; // 상태
          if(this.pharmacist.status == '1' || this.pharmacist.status == '13'){ // 승인완료, 반려로 바꿨을때만 승인(반려)자와 승인(반려)일시(api에서 넣음) update 한다
            data.pharmacist.approver = this.account.pharm_id; // 승인자
          }
        }

        data.pharmacist.pharmacy_fax = this.pharmacist.pharmacy_fax;
        data.pharmacist.latitude = this.pharmacist.latitude;
        data.pharmacist.longitude = this.pharmacist.longitude;
        data.pharmacy.addr_short = this.pharmacy.addr_short;
        data.pharmacy.location = this.pharmacy.location;
        data.pharmacy.addr_detail = this.pharmacy.addr_detail;
        data.pharmacy.pharm_tel = this.pharmacy.pharm_tel;
      }
      await this.axios({
        method: 'post',
        url: '/pharmacist/account/' + this.pharmacist.pharm_id,
        data: data,
      }).then((response) => {
        //console.log(response);
        if(!response.data.has_error){ //성공
          alert('저장 되었습니다.')
          // console.log('success');
        }else{ //실패
          alert('오류가 발생 하였습니다.')
          // console.log('error');
          // console.log(response);
        }
      }).catch((error) => {
        console.log('error!: ', error);
      }).finally(() => {
        this.reloadData();
        this.is_click = true;
      });
    },
    async reloadData(){
      await this.getPharmacistData(this.current_pharmacist_id);
      await this.getPharmacistSubData(this.current_pharmacist_id);
      await this.getPharmacyData(this.pharmacist.pharmacy_id);
      await this.set_pharmacist_arr();
      await this.set_manager_arr();
      await this.getBank();
      await this.location_list();
      await this.getPharmacistListData(this.page_no, 'N'); // N -> 현재 선택한 병원 유지

      // 실행 순서의 문제인지 license_img 가 제대로 안넣어짐 수동으로 다시 넣는다
      // let tempUrl = this.pharmacist.license_img;
      // this.pharmacist.license_img = null;
      // this.pharmacist.license_img = tempUrl;
    },
    async set_manager_arr(){
      let managerTempArr = new Array();
      
      if(this.pharmacy.manager.length > 0){
        for(let i=0; i<this.pharmacy.manager.length; i++){
          let managerObj = new Object();
          managerObj.manager = this.pharmacy.manager[i];
          managerObj.manager_tel = this.pharmacy.manager_tel[i];
          
          if(this.pharmacy.manager_tel.length > 0){
            let split = this.pharmacy.manager_tel[i].split('-');
            if(split.length >= 3){
              managerObj.manager_tel1 = split[0];
              managerObj.manager_tel2 = split[1];
              managerObj.manager_tel3 = split[2];
            }else{
              managerObj.manager_tel1 = '';
              managerObj.manager_tel2 = '';
              managerObj.manager_tel3 = '';
            }
          }
          managerTempArr.push(managerObj);
        }
      }
      this.pharmacy.manager_arr = managerTempArr;
    },
    async set_new_manager_arr(name, tel){
      //Manager컴포넌트에 manager_arr배열로 넘겨줬던 
      //manager, manager_tel이 변경될때마다(watch) 값을 다시 받아 manager, manager_tel에 변경된 값 할당
      this.pharmacy.manager = name;
      this.pharmacy.manager_tel = tel;
    },
    async set_pharmacist_arr(){
      let pharmacistTempArr = new Array();
      
      if(this.pharmacist.pharmacist.length > 0){
        for(let i=0; i<this.pharmacist.pharmacist.length; i++){
          let pharmacistObj = new Object();
          pharmacistObj.manager = this.pharmacist.pharmacist[i];
          pharmacistObj.manager_tel = this.pharmacist.pharmacist_tel[i];
          
          if(this.pharmacist.pharmacist_tel.length > 0){
            let split = this.pharmacist.pharmacist_tel[i].split('-');
            if(split.length >= 3){
              pharmacistObj.manager_tel1 = split[0];
              pharmacistObj.manager_tel2 = split[1];
              pharmacistObj.manager_tel3 = split[2];
            }else{
              pharmacistObj.manager_tel1 = '';
              pharmacistObj.manager_tel2 = '';
              pharmacistObj.manager_tel3 = '';
            }
          }
          pharmacistTempArr.push(pharmacistObj);
        }
      }
      this.pharmacist.pharmacist_arr = pharmacistTempArr;
    },
    async set_new_pharmacist_arr(name, tel){
      //Manager컴포넌트에 doctor_arr배열로 넘겨줬던 
      //doctor, doctor_tel이 변경될때마다(watch) 값을 다시 받아 doctor, doctor_tel에 변경된 값 할당
      this.pharmacist.pharmacist = name;
      this.pharmacist.pharmacist_tel = tel;
    },
    async searchDoorHospitalPopup(){
      this.is_modal = true;
    },
    async selectDoorHospital(hospital) {
      if(hospital.dr_id){
        this.pharmacy.door_pharmacy_dr_id = hospital.dr_id; // 문전 약국 연계병원 id(doctor.dr_id)
        this.pharmacy.door_pharmacy_dr_name = hospital.dr_name; // 문전 약국 연계병원 id(doctor.dr_name)
      }
      this.is_modal = false;
    },
    async justClosePopup(){
      this.is_modal = false;
    },
  },
  async mounted () {
    await this.getPharmacistListData();
    await this.location_list();
  },
  watch: {
    current_pharmacist_id: async function (current_pharmacist_id){
      // Object.assign(this.$data.hosp, this.$options.data().hosp);
      if(current_pharmacist_id){
        this.tab = 1; // 이걸 안해주고 tab 3에서 다른 row 들어가면 제대로 세팅이 안된다 왜그럴까 ?
        await this.getPharmacistData(current_pharmacist_id);
        await this.getPharmacistSubData(current_pharmacist_id);
        await this.getPharmacyData(this.pharmacist.pharmacy_id);
        await this.set_pharmacist_arr();
        await this.set_manager_arr();
        await this.getBank();
      }
    }
  },
  components: {
    Manager, DoorHospital, vPagination, ContactInput, Location
  }
}
</script>

<style scoped>
  .wrap {
    width: 100%;
    max-width: 1280px;
    margin: 55px auto;
  }
  .wrap > h2 {
    color: #494949;
    margin-bottom: 30px;
    letter-spacing: -.5px;
    font: 400 24px 'Noto Sans KR', sans-serif;
  }
  .wrap > div {
    width: 100%;
    box-sizing: border-box;
  }
  .wrap .profile-btn {
    height: 50px;
    margin: 20px auto;
    background:none;
    border:0;
    text-align:center;
  }
  .wrap .profile-btn button {
    display:inline-block;
    color: #8d8d8d;
    width: 160px;
    height: 100%;
    margin: 0 10px;
    border: none;
    padding: 0;
    outline: 0;
    cursor: pointer;
    background-color: #707070;
    font: 400 18px/48px 'Noto Sans KR', sans-serif;
    color:#fff;
  }
  .wrap .profile-btn button.btn_sv{
    background-color: #5e71e9;
  }
  .btn_search{
    display:inline-block;
    min-width:70px;
    height:30px;
    line-height:30px;
    margin:0 10px;
    background:#5e71e9;
    font-size:12px;
    color:#fff;
    text-align:center;
    cursor:pointer;
    border: none;
  }

  /* .profile-img-change {
    height: 30px;
    width: 30px;
    background-color: white;
    border: 1px solid #e5e5e5;
    text-align: center;
    line-height: 38px;
    border-radius: 50%;
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
  .camera-icon {
    color: #a1a1a1
  }  */


  .prfle .recommend{
    display:inline-block;
    margin-top:10px;
  }
  .prfle .recommend > p {
    text-indent: 25px;
    font: 500 14px 'Noto Sans KR', sans-serif;
    background: url(../assets/home/star.png) 0 center/18px no-repeat;
  }
  .srch_area{margin-bottom:20px}
  .srch_area select{
    float:left;
    width:100px;
    height:35px;
    padding:0 10px;
    margin-right:10px;
    border:1px solid #bebebe;
    text-align:center;
    background: url(../assets/home/select.png) 98% no-repeat;
    background-color:#fff;
  }
  .srch_area .srch_box{overflow:hidden;}
  .srch_area .srch_box input{width:100%; height:35px; padding:0 10px; border:1px solid #bebebe; box-sizing:border-box; -webkit-box-sizing:border-box;}
  .srch_area .btn_srch{float:right; width:75px; height:35px; line-height:35px; margin-left:10px;; background:#5e71e9; text-align:center; cursor:pointer; color:#fff;}
  
  /* 페이징 영역 강제 설정 */
  .hp_list .tb_area{text-align:center; padding:0 0 70px; font-size:14px;}
  
  .hp_list .tb_area table{background-color:#fff;}
  .hp_list .tb_area td{height:16px; line-height:1.4; padding:10px 5px; word-break:break-all;}
  .hp_list tbody tr {
    cursor: pointer;
  }
  .hp_list tbody tr:hover,
  .hp_list tbody tr.on {
    background-color: #f5f6fa;
  }

  /* tab영역 */
  .mmbr_info .tab{font-size:0;}
  .mmbr_info .tab li{display:inline-block; width:33.3%; height:30px; line-height:30px; font-size:14px; color:#fff; text-align:center; background:#9ba9ff; cursor:pointer;}
  .mmbr_info .tab li.on{background:#5e71e9;}
  .mmbr_info .tab li a{display:block;}
  
  /* 계정관리 */
  /* .tab_cont{overflow:hidden;}
  .tab_cont > div{background-color: #fff; border: 1px solid #eee; box-sizing:border-box; -webkit-box-sizing:border-box;}
  .tab_cont > div +  div{margin-top:10px;}
  .thmb_area{float:left; width:160px; text-align:center;}
  .thmb_area .thmb{overflow:hidden; width:100px; height:100px; margin:30px auto 20px; border:1px solid #ddd; border-radius:50%; text-align:center;}
  .thmb_area .thmb:after{content:""; display:inline-block; height:100%; vertical-align:middle;}
  .thmb_area .thmb img{display:inline-block; vertical-align:middle; max-width:100%; max-height:100%;}
  .thmb_area .name{padding:0 5px; line-height:1.4; font-size:16px; font-weight:bold;}
  .thmb_area .stt{display:inline-block; min-width:100px; height:30px; line-height:30px; margin:30px 0 40px; background:#5e71e9; font-size:12px; color:#fff;} */
  .tab_cont{overflow:hidden;}
  .tab_cont > div{background-color: #fff; border: 1px solid #eee; box-sizing:border-box; -webkit-box-sizing:border-box;}
  .tab_cont > div +  div{margin-top:10px;}
  .thmb_area{float:left; width:160px; text-align:center;}
  .thmb_area .thmb{position:relative;}
  .thmb_area .thmb_img{
    overflow:hidden;
    width:100px;
    height:100px;
    margin:30px auto 20px;
    border:1px solid #ddd;
    border-radius:50%;
    text-align:center;
    background: url('../assets/home/profile-default.jpg') center center no-repeat;
  }
  .thmb_area .thmb_img:after{content:""; display:inline-block; height:100%; vertical-align:middle;}
  .thmb_area .thmb_img img{display:inline-block; vertical-align:middle; max-width:100%; max-height:100%;}
  .thmb_area .name{padding:0 5px; line-height:1.4; font-size:16px; font-weight:bold;}
  .thmb_area .stt{display:inline-block; min-width:100px; height:30px; line-height:30px; margin:30px 0 40px; background:#5e71e9; font-size:12px; color:#fff;}

  .profile-img-change {
    height: 30px;
    width: 30px;
    background-color: white;
    border: 1px solid #e5e5e5;
    text-align: center;
    line-height: 32px;
    border-radius: 50%;
    position: absolute;
    bottom: 5px;
    right: 20px;
  }
  .camera-icon {
    color: #a1a1a1
  } 

  .info_area{overflow:hidden; min-height:234px; padding:20px; border:solid #eee; border-width:0 0 0 1px;}
  .info_area dl + dl{margin-top:50px}
  .info_area dl dt{margin-bottom:10px; font-size:18px; font-weight:bold; color:#3e3e3e;}
  .info_area ul{
    font-size:0;
    padding: 10px;
  }
  .info_area li{display:inline-block; width:33.3333%; margin-bottom:10px; line-height:30px; font-size:14px; color:#3e3e3e; vertical-align:middle;}
  .info_area .tt{float:left; width:70px; padding:0 10px; text-align:center;}
  .info_area .txt_box{line-height:1.4; margin:10px 20px; font-size:13px;}
  .info_area .tt_box{margin-top:15px;}
  .info_area .tt_box + .tt_box{margin-top:25px;}
  .info_area .tt_box .tt{float:none; width:auto; text-align:left;}
  .info_area .tt_box textarea{width:100%; margin:10px; border:1px solid #e7e7e9; box-sizing:border-box; -webkit-box-sizing:border-box; resize:none;}
  .info_area .tt_box li{width:140px;}
  .info_area .tt_box .thmb{overflow:hidden; width:125px; height:80px; margin:10px auto 0; border:1px solid #ddd; text-align:center;}
  .info_area .tt_box .thmb:after{content:""; display:inline-block; height:100%; vertical-align:middle;}
  .info_area .tt_box .thmb img{display:inline-block; vertical-align:middle; max-width:100%; max-height:100%;}
  .info_area .input_box{overflow:hidden; display:block;}
  .info_area .input_box li{width:30.33333%; margin:0;}
  .info_area .input_box li:nth-child(2){margin:0 1.5%}
  .info_area input{width:100%; height:30px; padding:0 10px; border:1px solid #e7e7e9; box-sizing:border-box; -webkit-box-sizing:border-box; text-align:center;}
  .info_area strong{color:#c71b31;}
  .info_area .msg{color:#0066ff; font-size:11px;}
  .info_area .btn_add{display:inline-block; min-width:70px; height:30px; line-height:30px; margin:0 10px; background:#5e71e9; font-size:12px; color:#fff; text-align:center; cursor:pointer;}

  .tb_area{border:none}
  .tb_area table{width:100%; text-align:center;}
  .tb_area th,
  .tb_area td{border:1px solid #e7e7e9; padding:10px; vertical-align:middle;}
  .tb_area th{padding:10px 15px; font-size:14px; color:#fff; text-align:center; background:#a7a7a7;}
  .tb_area td{min-height:14px; font-size:14px; vertical-align:middle;}
  .tb_area input[type="checkbox"],
  .tb_area input[type="radio"]{display:inline-block; margin-top:-3px; margin-right:5px; margin-bottom:0; vertical-align:middle;}
  .tb_area input[type="file"]{visibility:hidden; width:0; margin:0;}
  .tb_area .file_box{float:left; margin-right:5px;}
  .tb_area .file_box .btn_file{display:inline-block; height:24px; line-height:24px; padding:0 10px; color:#fff; background:#5e71e9; font-size:11px; cursor:pointer; vertical-align:top;}
  .tb_area .file_lnk{overflow:hidden; max-width:175px; text-align:left;}
  .tb_area .file_lnk a{
    display:block;
    height:24px;
    line-height:24px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    color:#0023ff;
    text-decoration:underline;
    cursor: pointer;
  }
  .tb_area label + input{margin-left:20px;}
  .tb_area .show_type{margin-right:20px;}

  .tb_area .tb_box{padding:0;}
  .tb_area .tb_box td{padding:5px;}
  .tb_area .tb_box select{
    width:100px;
    height:25px;
    padding:0 10px;
    margin-right:10px;
    border:1px solid #bebebe;
    text-align:center;
    background: url(../assets/home/select.png) 98% no-repeat;
  }
  .is_hospital_select{
    width:100px;
    height:25px;
    padding:0 10px;
    margin-right:10px;
    border:1px solid #bebebe;
    text-align:center;
    background: url(../assets/home/select.png) 98% no-repeat;
  }
  .tb_area .input_box{padding:5px 10px;}
  .tb_area .input_box input[type="text"]{width:100%; height:35px; padding:0 10px; border:1px solid #ebebeb; box-sizing:border-box; -webkit-box-sizing:border-box;}
  .tb_area dt{float:left; width:60px; height:20px; line-height:20px; font-size:12px; text-align:left;}
  .tb_area dd{overflow:hidden; margin:3px 0;}
  .tb_area dd select,
  .tb_area dd input{width:100%; height:20px; padding:0 5px; border:1px solid #ebebeb; box-sizing:border-box; -webkit-box-sizing:border-box;}
  .tb_area dd select{background: url(../assets/home/select.png) 98% no-repeat;}
  .row_type td{text-align:left;}
  .tb_area .agree th{background-color:#5e71e9;}
  .tb_area .agree .sub_th th{background:#a7a7a7;}
  .tb_area .agree textarea{width:100%; padding:10px; border:1px solid #bdbdbd; box-sizing:border-box; -webkit-box-sizing:border-box;}
  .tb_area .agree .ck_box{margin:10px 0; text-align:right;}
  .tb_area .dvic .dvck_box{float:left; line-height:35px; margin-right:10px;}
  .tb_area .dvic .input_box{display:block; padding:0; overflow:hidden;}
  .tb_area .specialty_id{
    width:100%;
    height:45px;
    line-height:45px;
    padding:0 10px;
    border:1px solid #ebebeb;
    box-sizing:border-box;
    -webkit-box-sizing:border-box;
    background: url(../assets/home/select.png) 98% no-repeat;
  }

  .hp_info{background-color:#fff;}
  .hp_info h3{height:30px; line-height:30px; font-size:14px; color:#fff; background:#5e71e9; text-align:center;}
  .hp_info select,
  .hp_info input[type="text"]{width:100%; height:45px; line-height:45px; padding:0 10px; border:1px solid #ebebeb; box-sizing:border-box; -webkit-box-sizing:border-box;}
  .hp_info select{background: url(../assets/home/select.png) 98% no-repeat;}
  .hp_info table{width:100%;}
  .hp_info table th,
  .hp_info table td{border:1px solid #e7e7e9; padding:10px; vertical-align:middle;}
  .hp_info table th{width:13%; padding:10px 15px; font-size:14px; color:#fff; background:#a7a7a7; text-align:center;}
  .hp_info table td{width:87%; vertical-align:middle;}
  .hp_info table .sb_tt{display:block; margin-top:5px; font-size:10px;}
  .hp_info table textarea{width:100%; padding:10px; font-size:12px; border:1px solid #e7e7e9; box-sizing:border-box; -webkit-box-sizing:border-box; resize:none;}
  .hp_info .time{padding:0;}
  .hp_info .time tr:nth-child(even){background:#f5f6fa;}
  .hp_info .time th,
  .hp_info .time td{border:0;}
  .hp_info .time th{text-align:center; border:solid #e7e7e9; border-width:0 1px 0 0;}
  .hp_info .time select{width:44%; margin-left:5px; height:25px; line-height:25px; background-position-x:95%;}
  .hp_info .btn{display:inline-block; min-width:75px; height:45px; line-height:45px; padding:0 10px; font-size:12px; cursor:pointer; background:#5e71e9; color:#fff; vertical-align:middle; text-align:center;}
  .hp_info .addr_srch{float:left; margin-right:10px;}
  .hp_info .addr_srch select{display:inline-block; width:110px; margin-right:10px; vertical-align:middle;}
  .hp_info .addr_box{overflow:hidden;}
  .hp_info .addr_box .addr{width:49.5%;}
  .hp_info .addr_box .addr:first-child{background: rgb(220, 220, 220);}
  .hp_info .addr_box .addr:last-child{margin-left:1%;}
  .hp_info .lnk_box + .lnk_box{margin-top:10px;}
  .hp_info .lnk_box .btn{float:right; margin-left:10px;}
  .hp_info .lnk_box .ov{overflow:hidden;}
  .hp_info .msg{margin-top:10px; color:#898989; font-size:12px;}
  .hp_info.sc th{width:5%;}
  .hp_info.sc td{text-align: center;}
  .hp_info.sc input[type="radio"]{margin:0 5px 0 25px;}


  .modal {
      display: block; /* Hidden by default */
      position: fixed; /* Stay in place */
      opacity:0.99;
      z-index: 100; /* Sit on top */
      padding: 0; /* Location of the box */
      left: 0;
      top: 0;
      width: 100% !important; /* Full width */
      height: 100%; /* Full height */
      overflow: auto; /* Enable scroll if needed */
      background-color: rgb(9,9,9) !important; /* Fallback color */
      background-color: rgba(0,0,0,0.4) !important; /* Black w/ opacity */
  }
  .modal-content {
      position: relative;
      background-color: #fefefe;
      margin: auto;
      margin-top: 100px;
      padding: 0;
      border: 1px solid #888;
      width: 700px;
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
      -webkit-animation-name: animatetop;
      -webkit-animation-duration: 0.4s;
      animation-name: animatetop;
      animation-duration: 0.4s
  }
  .modal-header {
      padding: 5px 20px;
      background-color: #111;
      color: white;
  }
  .modal-body {padding: 0px 0px;}
  .modal-footer {
      padding: 2px 10px;
      background-color: #111;
      color: white;
  }
  .close {
      color: white;
      float: right;
      font-size: 30px;
      font-weight: bold;
  }
  .close:hover,
  .close:focus {
      color: #000;
      text-decoration: none;
      cursor: pointer;
  }
  .modal-header h1 {
      margin-bottom: 10px;
      font: 400 20px 'Noto Sans KR', sans-serif;
  }
  .modal-header {
      padding: 10px 20px;
      background-color: #111;
      color: white;
  }
  .modal-body {padding: 10px 20px;}
  .modal-footer {
      padding: 2px 10px;
      background-color: #111;
      color: white;
  }
</style>
